import React from 'react';
import Exhibition from './Exhibition';

function ExhibitionList({ title, items }) {
    return (
        <>
            <h3 className="cv-section">{title}</h3>
            <ul className="cv-list">
                {items.map((item, idx) => (
                    <li key={idx}>
                        <Exhibition item={item} />
                    </li>
                ))}
            </ul>
        </>
    );
}

export default ExhibitionList;